import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { REGISTER_URL } from '../../pricing';

const { FiChevronDown, FiChevronUp } = FiIcons;

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'จำเป็นต้องมีความรู้ด้านโหราศาสตร์จีนก่อนไหม?',
      answer: 'ไม่จำเป็น นักพรตจะอธิบายทุกขั้นตอนให้เข้าใจ เหมาะสำหรับทุกระดับความรู้'
    },
    {
      question: 'ทำไมจำกัดจำนวนผู้เข้าร่วม?',
      answer: 'เพื่อให้การดูแลทั่วถึง และการทำพิธีเป็นไปอย่างพิถีพิถัน ไม่รีบเร่ง'
    },
    {
      question: 'หากสภาพอากาศไม่เอื้ออำนวย?',
      answer: 'มีการติดตามสภาพอากาศล่วงหน้า หากจำเป็นต้องเลื่อน จะแจ้งล่วงหน้าอย่างน้อย 3 วัน'
    },
    {
      question: 'ต้องเตรียมสิ่งของอะไรไปบ้าง?',
      answer: 'ที่ด้านหน้าทางเข้าจะมีของสักการะ ธุป เทียน และทำบุญข้าวสาร พร้อม ท่านไม่ต้องเตรียมมา สามารถร่วมบุญกับทางศาลเจ้าพ่อเขาใหญ่ได้เลย'
    },
    {
      question: 'เหมาะกับทุกความเชื่อไหม?',
      answer: 'พิธีนี้เป็นไปตามความเชื่อทางพุทธ-เต๋า สามารถร่วมได้ทุกศาสนา'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-10 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            คำถามที่พบบ่อย
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            คำตอบสำหรับคำถามที่ผู้สนใจมักจะสงสัย
          </p>
        </motion.div>

        <div className="max-w-3xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none"
                >
                  <span className="text-lg font-semibold text-gray-900">
                    {faq.question}
                  </span>
                  <SafeIcon
                    icon={openIndex === index ? FiChevronUp : FiChevronDown}
                    className="w-5 h-5 text-gray-500 transition-transform duration-200"
                  />
                </button>
                
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{
                    height: openIndex === index ? 'auto' : 0,
                    opacity: openIndex === index ? 1 : 0
                  }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <div className="px-6 pb-4">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </motion.div>
              </motion.div>
            ))}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-8 text-center"
        >
          <div className="bg-gradient-to-r from-red-50 to-amber-50 border border-red-200 rounded-xl p-8 max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 font-medium">
              หากมีคำถามเพิ่มเติม สามารถติดต่อสอบถามได้ตามช่องทางที่ระบุไว้
              <br />
              <span className="text-red-700 font-semibold">
                ทีมงานพร้อมให้คำปรึกษาและแนะนำอย่างละเอียด
              </span>
            </p>
          </div>
        </motion.div>

        <div className="mt-8 text-center">
          <a
            href={REGISTER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-3 bg-gradient-to-r from-green-600 to-green-700 text-white font-bold rounded-full hover:from-green-700 hover:to-green-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            ลงทะเบียนเข้าร่วมทริปนี้
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;